/** @format */
import BlogGridHuge from "@Web/Blocks/BlogGridHuge";
import { Box, Typography } from "@mui/material";
import { useLocales } from "locales";

const LatestStories = (props) => {
  const { t } = useLocales();
  return (
    <Box>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={{ xs: "flex-start", sm: "center" }}
        flexDirection={{ xs: "column", sm: "row" }}
        marginBottom={4}
      >
        <Box>
          <Typography fontWeight={700} variant={"h6"} gutterBottom>
            {t("latestStories")}
          </Typography>
          <Typography color={"text.secondary"}>{t("heresWhatWereUpTo")}</Typography>
        </Box>
      </Box>
      <BlogGridHuge {...props} />
    </Box>
  );
};

export default LatestStories;
